<template>
  <v-container fluid class="pl-7 pr-6">
    <WorklistTable class="elevation-1 mt-5" />
  </v-container>
</template>

<script>
import WorklistTable from "../components/Worklist/WorklistTable.vue";

export default {
  name: "Worklist",
  components: {
    WorklistTable,
  }
};
</script>

<style scoped>
</style>